import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface FlexProps {
  children?: React.ReactNode;
  direction?: 'row' | 'column';
  align?: 'flex-start' | 'center' | 'flex-end' | 'stretch';
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around';
  gap?: 'small' | 'medium' | 'large';
  wrap?: boolean;
  className?: string;
}

const StyledFlex = styled.div<FlexProps>`
  display: flex;
  ${({ direction = 'row' }) => `flex-direction: ${direction};`}
  ${({ align = 'stretch' }) => `align-items: ${align};`}
  ${({ justify = 'flex-start' }) => `justify-content: ${justify};`}
  ${({ wrap }) => wrap && 'flex-wrap: wrap;'}
  
  ${({ gap }) => {
    switch (gap) {
      case 'small': return `gap: ${theme.spacing.sm};`;
      case 'medium': return `gap: ${theme.spacing.md};`;
      case 'large': return `gap: ${theme.spacing.lg};`;
      default: return '';
    }
  }}
`;

export const Flex: React.FC<FlexProps> = ({ children, ...props }) => {
  return (
    <StyledFlex {...props}>
      {children}
    </StyledFlex>
  );
};